import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://tqbuiyfenxtwvizswuyq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRxYnVpeWZlbnh0d3ZpenN3dXlxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgyNzk5MjQsImV4cCI6MjA4Mzg1NTkyNH0.hYzDS4l4dxRQ3J39-U8EvZumbA0w6E8D847g2htvlrE';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
